import { AssistanceFailureServiceMock } from "./assistanceFailure.types";

export const mockAssistanceFailureService = (): AssistanceFailureServiceMock => ({
  fetchAssistanceFailures: jest.fn(),
});
